import { render, staticRenderFns } from "./UserLocation.vue?vue&type=template&id=8da06b5e"
import script from "./UserLocation.vue?vue&type=script&lang=js"
export * from "./UserLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports